import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=74e2f94e&"
import script from "./PageFooter.vue?vue&type=script&lang=js&"
export * from "./PageFooter.vue?vue&type=script&lang=js&"
import style0 from "./PageFooter.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SubscribeForm: require('/opt/build/repo/storefront/components/molecules/Form/SubscribeForm.vue').default,IconButton: require('/opt/build/repo/storefront/components/atoms/Button/IconButton.vue').default,BaseCopy: require('/opt/build/repo/storefront/components/atoms/Text/BaseCopy.vue').default,BaseTag: require('/opt/build/repo/storefront/components/atoms/Tags/BaseTag.vue').default,SimpleLink: require('/opt/build/repo/storefront/components/atoms/Link/SimpleLink.vue').default})
